import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isEmpty, isUndefined } from "lodash";
import { history } from "@helpers/history";
import Tarjeta from "./Tarjeta";
import TarjetasListado from "./TarjetasListado";
import { remAccents } from "@helpers/utils.js";
import { animations } from "react-animation";

function TarjetasContainer(props) {
  const {
    match: { params },
  } = props;
  const [viewDetail, setViewDetail] = useState(0);
  const [matches, setMatches] = useState([]);

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);

  const { tarjetasCredito } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  useEffect(() => {
    const defRoute = rutas?.filter(
      (route) => route?.name === "Tarjetas Listado"
    );

    const prevRoute = defRoute.map((route) => {
      return {
        url: route.url,
        text: route.title,
      };
    });
    let promise = new Promise((resolve, reject) => {
      const idCard = params?.id;
      let normalizeCards =
        tarjetasCredito &&
        tarjetasCredito?.map((card) => ({
          ...card,
          nombre: remAccents((card?.titulo).replace(/ /gi, "-").toLowerCase()),
          rutaPrevia: prevRoute,
        }));
      let resMatch =
        normalizeCards &&
        normalizeCards?.filter((card) => card.nombre === idCard);
      resolve(resMatch);
    });

    promise.then((resultado) => {
      if (!isUndefined(resultado)) {
        if (isUndefined(params.id)) {
          setViewDetail(2);
        } else {
          if (!isEmpty(resultado)) {
            setMatches(resultado);
            setViewDetail(1);
          } else {
            setViewDetail(3);
          }
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tarjetasCredito]);

  useEffect(() => {
    viewDetail === 3 && history.push("/no-encontrado");
  }, [viewDetail]);

  const renderResultView = () => {
    return viewDetail === 1 ? (
      <Tarjeta dataCard={matches} style={{ animation: animations.fadeIn }} />
    ) : viewDetail === 2 ? (
      <TarjetasListado style={{ animation: animations.fadeIn }} />
    ) : null;
  };

  return <>{renderResultView()}</>;
}

export default TarjetasContainer;
